module.exports = __webpack_public_path__ + "img/nikola.d3c60a24.png";